import { useCallback, useContext } from "react";
import { match } from "ts-pattern";
import Button, { EButtonVariant } from "components/elements/Button";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { ETab, TabContext } from "components/pages/FeaturedProjects/contexts/Tab";
import classes from "./classes.module.scss";

type IButtonTabProps = {
	tab: ETab;
};

export default function Tabs() {
	return (
		<div className={classes["root"]}>
			<ButtonTab tab={ETab.VOTES} />
			<ButtonTab tab={ETab.ACTIONS} />
			<ButtonTab tab={ETab.FORUM} />
			<ButtonTab tab={ETab.CASTING} />
			<ButtonTab tab={ETab.MEDIA} />
			<ButtonTab tab={ETab.TEAM} />
		</div>
	);
}

function ButtonTab(props: IButtonTabProps) {
	const { isActiveTab, setActiveTab, isTabEnabled } = useContext(TabContext);

	const getTabTitle = useCallback((tab: ETab) => {
		return match(tab)
			.with(ETab.VOTES, () => I18n.asset.pages.project.tabs.votes)
			.with(ETab.ACTIONS, () => I18n.asset.pages.project.tabs.actions)
			.with(ETab.FORUM, () => I18n.asset.pages.project.tabs.forum)
			.with(ETab.CASTING, () => I18n.asset.pages.project.tabs.casting)
			.with(ETab.MEDIA, () => I18n.asset.pages.project.tabs.media)
			.with(ETab.TEAM, () => I18n.asset.pages.project.tabs.team)
			.exhaustive();
	}, []);

	const onClick = useCallback(() => setActiveTab(props.tab), [props, setActiveTab]);

	return (
		<Button variant={EButtonVariant.SELECTOR} onClick={onClick} isSelected={isActiveTab(props.tab)} disabled={!isTabEnabled(props.tab)}>
			<Typography type="p" size="medium" weight="bold">
				{getTabTitle(props.tab)}
			</Typography>
		</Button>
	);
}
